import template from './app.pug';
import controller from './app.controller';

const AppComponent = {
  template,
  controller,
};

export default AppComponent;



// WEBPACK FOOTER //
// ./client/app/app.component.js